import { Button, Icon } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { useNavigate } from 'react-router-dom'

export const BackButton = () => {
  const { colors } = useTheme()
  const navigate = useNavigate()

  return (
    <Button
      aria-label="go back to previous page"
      className={css`
        padding: 0 16px;
        position: absolute;
        inset: 16px auto auto 16px;
        z-index: 2;
        width: auto;
        gap: 8px;
        background-color: rgba(0, 0, 0, 0.2);
        border-color: transparent;
        &:hover {
          background-color: rgba(0, 0, 0, 0.5);
          border-color: transparent;
        }
      `}
      onClick={() => navigate(-1)}
      small
    >
      <Icon
        className={css`
          width: 8px;
        `}
        type="chevron-left"
        fill={colors.uiWhite}
      />
      Back
    </Button>
  )
}
